import axios, { AxiosResponse } from 'axios'
import {
  CertificateRequest,
  EnvelopeInfoRequest,
  UserEnvelopeProcessRequest,
} from '../models/RequestModel'
import {
  AccountDetailedInfo,
  Certificate,
  CreateContractResponse,
  EnvelopeStatus,
  SetSignedContentResponse,
} from '../models/ResponseModel'
import { SmartCard } from '../pages/MainPage/types'

const BASE_URL = 'https://contract.nesbilgi.com.tr/ContractSigner'
const API_BASE_URL = 'https://api.nesbilgi.com.tr'
export const LOCAL_SERVICE_BASE_URL = 'https://localhost.aktivasyon.nesbilgi.com.tr:15110'

export class SignerApi {
  public static async checkStepDetail(
    dealerCode: string,
    campainCode,
  ): Promise<AxiosResponse<boolean>> {
    return await axios.get(
      `${API_BASE_URL}/signer/stepdetail?campainCode=${campainCode}&dealerCode=${dealerCode}`,
    )
  }

  public static async previewContract(params: any): Promise<AxiosResponse<CreateContractResponse>> {
    return await axios.post(`${BASE_URL}/signcontract`, params)
  }

  public static async accountCreate(params: any): Promise<AxiosResponse<CreateContractResponse>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/create`, params)
  }

  public static async lawyerQuery(params: any): Promise<AxiosResponse<any>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/lawyer`, params)
  }

  public static async gibApplicationQuery(params: any): Promise<AxiosResponse<any>> {
    return await axios.get(`${LOCAL_SERVICE_BASE_URL}/gibApplication?registerNumber=${params}`)
  }

  public static async signDealerContract(
    params: any,
  ): Promise<AxiosResponse<CreateContractResponse>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/signdealercontract`, params)
  }

  public static async signCampainContract(
    params: any,
  ): Promise<AxiosResponse<CreateContractResponse>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/signcampaincontract`, params)
  }

  public static async getSmartCardList(): Promise<AxiosResponse<string[]>> {
    return await axios.get(`${LOCAL_SERVICE_BASE_URL}/smartcard`)
  }

  public static async getCertificateList(
    request: CertificateRequest,
  ): Promise<AxiosResponse<Certificate[]>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/smartcard/certificate`, request)
  }

  public static async getAccountInfo(
    request: SmartCard,
  ): Promise<AxiosResponse<AccountDetailedInfo>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/info`, {
      registerNumber: request.selectedCertificate!.serialNumber,
      smartCardInfo: {
        terminalName: request.selectedTerminal!,
        certificateId: request.selectedCertificate!.id,
        pin: request.pin,
        wrapperFile: request.wrapperFile,
        useApdu: request.useApdu,
      },
    })
  }

  public static async signAndSendUserEnvelope(
    request: UserEnvelopeProcessRequest,
  ): Promise<AxiosResponse<SetSignedContentResponse>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/sign/userenvelope`, {
      envelopeNumber: request.envelopeNumber,
      activationDate:
        request.activationDate !== undefined
          ? request.activationDate.format('YYYY-MM-DDTHH:mm:ss')
          : null,
      smartCardInfo: {
        terminalName: request.smartCard.selectedTerminal!,
        certificateId: request.smartCard.selectedCertificate!.id,
        pin: request.smartCard.pin,
        wrapperFile: request.smartCard.wrapperFile,
        useApdu: request.smartCard.useApdu,
      },
    })
  }

  public static async getEnvelopeInfo(
    request: EnvelopeInfoRequest,
  ): Promise<AxiosResponse<EnvelopeStatus>> {
    return await axios.post(`${LOCAL_SERVICE_BASE_URL}/account/envelope/info`, {
      registerNumber: request.smartCard.selectedCertificate!.serialNumber,
      envelopeId: request.envelopeId,
      smartCardInfo: {
        terminalName: request.smartCard.selectedTerminal!,
        certificateId: request.smartCard.selectedCertificate!.id,
        pin: request.smartCard.pin,
        wrapperFile: request.smartCard.wrapperFile,
        useApdu: request.smartCard.useApdu,
      },
    })
  }

  public static async signerPaymentRequest(request: any): Promise<AxiosResponse<any>> {
    return await axios.post(`https://odeme-api.nesbilgi.com.tr/signerpayment`, request)
  }
}
